import { JOBS_DELETED_EVENT } from "../../types/events/jobsDeleted.js";
import { JOBS_RETRIED_EVENT } from "../../types/events/jobsRetried.js";
import { JOBS_SKIPPED_EVENT } from "../../types/events/jobsSkipped.js";
import { request } from "../../utils/request.js";
import { locationRestJobResultPost } from "../../wp-api/jobResult.post.js";
async function saveJobResult(id, process, exception = {}) {
    const { code: errorCode, message: errorMessage, data: errorData } = exception;
    try {
        const result = await request({
            location: locationRestJobResultPost,
            request: {
                process,
                errorCode,
                errorMessage,
                errorData: errorData ? JSON.stringify(errorData) : undefined
            },
            params: {
                id
            }
        });
        if (result.pauseToAvoidRecurringException) {
            await new Promise((resolve)=>{
                const { job: { type } } = result;
                // Wait for user reactivates (delete, retry) the job
                const listenerDeleted = async ({ detail: { params: { type: deletedType } } })=>{
                    if (deletedType === type) {
                        document.removeEventListener(JOBS_DELETED_EVENT, listenerDeleted);
                        resolve();
                    }
                };
                const listenerRetried = async ({ detail: { request: { type: retriedType } } })=>{
                    if (retriedType === type) {
                        document.removeEventListener(JOBS_RETRIED_EVENT, listenerRetried);
                        resolve();
                    }
                };
                const listenerSkipped = async ({ detail: { request: { type: skippedType } } })=>{
                    if (skippedType === type) {
                        document.removeEventListener(JOBS_RETRIED_EVENT, listenerRetried);
                        resolve();
                    }
                };
                document.addEventListener(JOBS_DELETED_EVENT, listenerDeleted);
                document.addEventListener(JOBS_RETRIED_EVENT, listenerRetried);
                document.addEventListener(JOBS_SKIPPED_EVENT, listenerSkipped);
            });
        }
        return result;
    } catch (e) {
        // Something went wrong - but this should not be the case as we should always be able to store
        // job results. Let's wait a bit and try again
        await new Promise((resolve)=>setTimeout(resolve, 60 * 1000));
        return await saveJobResult(id, process, exception);
    }
}
export { saveJobResult };
